import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'antd/dist/reset.css'

import '../styles/style.css'
import Routes from './Routes'
import { light, dark } from './theme'
import { getUser } from '../redux'
// import { version } from './constants'
// import { notification } from 'antd'

import { io } from 'socket.io-client'
import { base_url } from './constants'
import { setSocket } from '../redux/actions/socketAction'

const App = () => {
  const theme = useSelector((state) => state.theme.theme)
  const dispatch = useDispatch()
  const authenticatedID = localStorage.getItem('token')
  const socket = io(base_url)

  // for the use if first connect
  useEffect(() => {
    if (authenticatedID) {
      socket.emit('join', authenticatedID)
      dispatch(setSocket(socket))
    }
  }, [authenticatedID])

  // for the use if reconnect
  useEffect(() => {
    socket.on('reconnect', () => {
      if (authenticatedID) {
        socket.emit('join', authenticatedID)
      }
    })
  }, [])

  // useEffect(() => {
  //   if (authenticatedID) {
  //     socket.emit('join', authenticatedID)
  //   }
  //   socket.on('connect', () => {
  //     console.log('connect', socket.id)
  //   })
  //   socket.on('disconnect', () => {
  //     console.log('disconnect', socket.id)
  //   })
  // }, [authenticatedID])

  // useEffect(() => {
  //   console.log('recconnect', socket.id)
  //   socket.on('reconnect', () => {
  //     if (authenticatedID) {
  //       socket.emit('join', authenticatedID)
  //     }
  //   })
  // }, [authenticatedID])

  useEffect(() => {
    if (theme === 'light') {
      Object.keys(light).forEach((key) => {
        document.body.style.setProperty(`--${key}`, light[key])
      })
    } else {
      Object.keys(dark).forEach((key) => {
        document.body.style.setProperty(`--${key}`, dark[key])
      })
    }
  }, [theme])

  useEffect(() => {
    // if (localStorage.getItem('version') !== version) {
    //   window.location.href = '/login'
    //   localStorage.clear()
    //   localStorage.setItem('version', version)
    //   notification.error({
    //     message: `Try login again!`,
    //     duration: 6,
    //   })
    // }
    if (localStorage.getItem('token')) {
      dispatch(getUser())
    }
  }, [])
  // return <></>
  return <Routes />
}

export default App
